import React from "react";

import { Box, Typography } from "@mui/material";

import { grayLight, orangeDark, tintOrange, white } from "design-system/colors";
import RoundChip from "design-system/components/chips/RoundChip";
import { NotificationSetting } from "types";

type CustomizedTextContentProps = {
  notificationSetting: NotificationSetting;
};

function CustomizedTextContent(props: CustomizedTextContentProps) {
  const { notificationSetting } = props;

  return (
    <Box
      bgcolor={white}
      height="100%"
      p={2}
      sx={{
        whiteSpace: "pre-line",
        border: `1px solid ${grayLight}`,
        borderRadius: "4px",
      }}
    >
      <Typography variant="overline">MESSAGE</Typography>
      <Box mt={3}>
        {formatContentToDisplay(notificationSetting.templateContent)}
      </Box>
    </Box>
  );
}

const formatContentToDisplay = (text: string) => {
  const parts = text.split(/(\{.*?\}|\\n)/g);

  return parts.map((part, index) => {
    if (part === "\\n") {
      return <br key={index} />;
    } else if (part.match(/^\{.*\}$/)) {
      return (
        <RoundChip
          label={part.slice(1, -1)}
          inputProps={{
            style: {
              backgroundColor: tintOrange,
              height: "30px",
              fontWeight: "normal",
              color: orangeDark,
            },
          }}
        />
      );
    } else {
      return <React.Fragment key={index}>{part}</React.Fragment>;
    }
  });
};

export default CustomizedTextContent;
